import React from "react";
import { FormattedHTMLMessage, injectIntl } from "react-intl";
import { FormSelectChoice, InputSelectComponentProps } from "../../../lib/types/types";
import { FieldLabel } from "../../FieldLabel";
import { InputSelectComponent } from "../../FormInputs/InputSelect/InputSelectComponent";

interface StatusComponentProps extends InputSelectComponentProps {
  segmentId: string;
  errorId?: string;
}

export const Status = ({
  value,
  isErrored,
  errorId = "invalidStatus",
  options,
  onChange,
  intl,
  placeholder = "",
  onKeyDown = undefined,
  segmentId,
}: StatusComponentProps) => {
  const inputId = `sid-${segmentId}-status`;
  const hasOnlyOneOption = options.length === 1;

  React.useEffect(() => {
    if (hasOnlyOneOption) {
      onChange(options[0]);
    }
  }, []);

  if (hasOnlyOneOption) {
    return null;
  }

  return (
    <div className={`sid-field ${inputId}`}>
      <div className="sid-l-space-top-md" />
      <FieldLabel
        text={<FormattedHTMLMessage id="status" defaultMessage="Status" />}
        htmlForLabel={inputId}
        id={`${inputId}-label`}
        displayClasses={placeholder && "sid-h-screen-reader-only"}
      />

      <InputSelectComponent
        fieldId="status"
        inputId={inputId}
        fieldLabelId={`${inputId}-label`}
        isErrored={isErrored}
        options={options}
        onChange={(status: FormSelectChoice) => onChange(status)}
        onKeyDown={onKeyDown}
        value={options.find((option) => option.value === (value && value.value))}
        placeholder={
          placeholder ||
          intl.formatHTMLMessage({ id: "statusPlaceholder", defaultMessage: "Status" })
        }
        isRequired
      />
      {isErrored ? (
        <div className="sid-field-error">
          <FormattedHTMLMessage
            id={`errorId.${errorId}`}
            defaultMessage={`Invalid ${segmentId} status`}
          />
        </div>
      ) : null}
    </div>
  );
};

export const StatusComponent = injectIntl(Status);
